import { Inject, Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../api-endpoints-constants';
import { IApiBaseObject } from '../../iModels/api-base-object.model';
import { IApiService } from '../../iservices/iApi';
import { ModelBindingService } from '../binding.model.service';
import { map } from 'rxjs/operators';
import { ModelDecoderBindingService } from '../bindingDecoder.model.service';
import { BehaviorSubject } from 'rxjs';
import { IPropertyDepartmentQueService } from '../../iservices/iPropertyMngServices/iPropertyDepartmentQue';
import { MatDialog } from '@angular/material/dialog';
// tslint:disable-next-line:max-line-length
import { AddPropertyDepartmentQueComponent } from '../../component/property-management/property-managementComponents/property-department-que/add-property-department-que/add-property-department-que.component';

@Injectable({
  providedIn: 'root'
})
export class PropertyDepartmentQueService implements IPropertyDepartmentQueService {
  dataHasBeenDeleted = new BehaviorSubject(false);
  tableUpdated = new BehaviorSubject(false);
  private apiObject: IApiBaseObject;
  constructor( @Inject('IApiService') private apiService: IApiService,
    private modelBindingService: ModelBindingService,
    public dialog: MatDialog,
    private modelDecoderBindingService: ModelDecoderBindingService) {

  }
  /*
    * @method getPropertyDepartmentQueDetails()
    * @desc used to get PropertyDepartmentQue list .
    * @return json array data.
  */
  getPropertyDepartmentQueDetails(apiGetParameters): any {
    let json;
    apiGetParameters.page = apiGetParameters.page ? apiGetParameters.page : 1;
    apiGetParameters.size = apiGetParameters.size === 0 || apiGetParameters.size ? apiGetParameters.size : 10;
    const url = this.modelBindingService.replaceUrl(
      API_ENDPOINTS.PROPERTY_DEPARTMENT_QUE_Get_ALL, apiGetParameters);
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.getApi(this.apiObject).pipe(
      map((resp) => {
        if (resp) {
          resp['data'] = this.modelDecoderBindingService
            .mappingDataReturn('propertyDepartmentQueDecoder', resp);
          if (resp['data'].data) {
            json = { data: resp['data'].data, 'itemCount': resp['data'].data[0].totalRows };
          } else {
            json = { data: resp['data'].data, 'itemCount': 0 };
          }
          return json;
        }
      }
      ));
  }
  /*
    * @method addPropertyDepartmentQue()
    * @desc used to add PropertyDepartmentQue Type.
    * @param permData :array - PropertyDepartmentQue data.
    * @return json array data.
  */
  addPropertyDepartmentQue(permData): any {
    const requestData = this.modelBindingService.propertyDepartmentQueEncoder(permData);
    this.apiObject = this.modelBindingService.setApiCallObject(API_ENDPOINTS.PROPERTY_DEPARTMENT_QUE_ADD, requestData,
      true, false);
    return this.apiService.postApi(this.apiObject).pipe(
      map((res) => {
        return res;
      },
        (error) => {
          return error;
        }
      ));
  }

  /*
    * @method getPropertyDepartmentQueDetailsById()
    * @desc used to get Property department que details by id.
    * @param id :string - id.
    * @return json array data.
  */
  getPropertyDepartmentQueDetailsById(id): any {
    const url = this.modelBindingService.replaceUrl(
      API_ENDPOINTS.PROPERTY_DEPARTMENT_QUE_by_id, {
        id: id
      });
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.getApi(this.apiObject).pipe(
      map((resp) => {
        if (resp) {
          resp['data'] = this.modelDecoderBindingService.propertyDepartmentQueDecoder(resp['data'][0]);
          return resp;
        }
      }));
  }
  /*
   * @method delete()
   * @desc used to delete row data.
   * @param id :array - Property department QUE id .
   * @param id :dialogType - dialogType .
   * @return string.
  */
  delete(id): string {
    const url = this.modelBindingService.replaceUrlForDelete(
      API_ENDPOINTS.PROPERTY_DEPARTMENT_QUE_DELETE, id);
    this.apiObject = this.modelBindingService.setApiCallObject(url, {}, true, false);
    return this.apiService.deleteApi(this.apiObject).pipe(
      map((response) => {
        return response;
      },
        (error) => {
          return error;
        }));
  }
}
